import styled from 'styled-components';

export const Heading = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 0;
`;
